import { User } from '@models/user';
import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser'
import { Router } from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import { TranslateService } from '@ngx-translate/core';

import { correctHeight, detectBody } from '@app/app.helpers';
import { CommonService } from '@app/services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit {

    @ViewChild('changePassword', { static: false }) changePassword;

    currentUser: User;
	public companyName: String;

    constructor(translate: TranslateService, private router: Router,
        private titleService: Title,
        public commonService: CommonService,
        private cdRef: ChangeDetectorRef
    ) {
        translate.use(commonService.getDefaultLang());
        
        commonService.getUserChangeEmitter().subscribe( user => {
            this.checkIfShowForceUpdatePassword();
        } );
    }

    ngOnInit(): void {

        setTheme('bs3');

        jQuery(document).bind('resize', function () {
            correctHeight();
            detectBody();
        });

        // Run correctHeight function on load and resize window event
        jQuery(window).bind('load resize', function () {
            correctHeight();
            detectBody();
        });

        // Correct height of wrapper after metisMenu animation.
        jQuery('.metismenu a').click(() => {
            setTimeout(() => {
                correctHeight();
            }, 300);
        });

        this.disableLoadingMask();
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
       // this.checkIfShowForceUpdatePassword();
    }


    public setContentBgTransparent() {
        jQuery('#page-wrapper').removeClass('wallpaper');
        jQuery('#page-wrapper').removeClass('gray-bg');
    }

    public setContentBgWallpaper() {
        jQuery('#page-wrapper').removeClass('gray-bg');
        jQuery('#page-wrapper').addClass('wallpaper');
    }

    public setContentBgGray() {
        jQuery('#page-wrapper').removeClass('wallpaper');
        jQuery('#page-wrapper').addClass('gray-bg');
    }

    public enableMenu(): void {
        jQuery('app-navigation').show();
        jQuery('#page-wrapper').removeClass('zero-margin');
    }

    public disableMenu(): void {
        jQuery('app-navigation').hide();
        jQuery('#page-wrapper').addClass('zero-margin');
    }

    public hideMenuCollapseButton(): void {
        jQuery('#menuCollapseButton').hide();
    }

    public showMenuCollapseButton(): void {
        jQuery('#menuCollapseButton').show();
    }

    public enableLoadingMask(): void {
        jQuery('#loading-mask').show();
        //   jQuery( 'body' ).css( 'overflow', 'hidden' );
    }

    public disableLoadingMask(): void {
        jQuery('#loading-mask').hide();
        //   jQuery( 'body' ).css( 'overflow', '' );
    }


    public checkIfShowForceUpdatePassword() {
            this.currentUser = this.commonService.getCurrentUser();
            if (this.currentUser && this.currentUser.isForceChangePassword && this.changePassword) {
                this.changePassword.open();
            }
    }

}
